/**
 * NO03 - Fakturakopi Reducer
 */

import NO03 from '../../models/NO03';
import FirmNavnId from '../../models/FirmNavnId';
import * as actionTypes from '../actions/actionTypesNO03';

export interface NO03State {
  invoices: NO03[];
  totalAmount: number;
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
  selectedFirma: FirmNavnId | null;
  firmaList: FirmNavnId[];
  firmaListLoading: boolean;
  isResetFormEnabled: boolean;
  currentPage: number;
  pageSize: number;
  hasMore: boolean;
  lastSearchParams: any;
}

const initialState: NO03State = {
  invoices: [],
  totalAmount: 0,
  loading: false,
  loadingMore: false,
  error: null,
  selectedFirma: null,
  firmaList: [],
  firmaListLoading: false,
  isResetFormEnabled: false,
  currentPage: 0,
  pageSize: 100,
  hasMore: true,
  lastSearchParams: null,
};

const NO03Reducer = (state = initialState, action: any): NO03State => {
  switch (action.type) {
    // Search
    case actionTypes.NO03_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentPage: 0,
        lastSearchParams: action.payload,
      };

    case actionTypes.NO03_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: action.payload.invoices,
        totalAmount: action.payload.invoices.reduce((sum: number, inv: NO03) => sum + inv.fakturatotal, 0),
        hasMore: action.payload.hasMore,
        currentPage: 0,
        error: null,
      };

    case actionTypes.NO03_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        invoices: [],
        totalAmount: 0,
        hasMore: false,
      };

    // Load More (Pagination)
    case actionTypes.NO03_LOAD_MORE_REQUEST:
      return {
        ...state,
        loadingMore: true,
        error: null,
      };

    case actionTypes.NO03_LOAD_MORE_SUCCESS:
      const newInvoices = [...state.invoices, ...action.payload.invoices];
      return {
        ...state,
        loadingMore: false,
        invoices: newInvoices,
        totalAmount: newInvoices.reduce((sum, inv) => sum + inv.fakturatotal, 0),
        hasMore: action.payload.hasMore,
        currentPage: state.currentPage + 1,
        error: null,
      };

    case actionTypes.NO03_LOAD_MORE_FAILURE:
      return {
        ...state,
        loadingMore: false,
        error: action.payload,
      };

    // Clear/Reset
    case actionTypes.NO03_CLEAR_RESULTS:
      return {
        ...state,
        invoices: [],
        totalAmount: 0,
        error: null,
        currentPage: 0,
        hasMore: true,
      };

    case actionTypes.NO03_RESET_FORM:
      return {
        ...state,
        isResetFormEnabled: action.payload,
      };

    // Firma
    case actionTypes.NO03_SET_FIRMA:
      return {
        ...state,
        selectedFirma: action.payload,
      };

    case actionTypes.NO03_LOAD_FIRMA_LIST:
      return {
        ...state,
        firmaListLoading: true,
      };

    case actionTypes.NO03_LOAD_FIRMA_LIST_SUCCESS:
      return {
        ...state,
        firmaList: action.payload,
        firmaListLoading: false,
      };

    case actionTypes.NO03_LOAD_FIRMA_LIST_FAILURE:
      return {
        ...state,
        firmaListLoading: false,
        error: action.payload,
      };

    // Component Store Management
    case actionTypes.NO03_CLEAR_COMPONENT_STORE:
      return initialState;

    default:
      return state;
  }
};

export default NO03Reducer;
